import { gql } from '@apollo/client'

export const ADD_GUARDIAN = gql`
  mutation AP_AddGuardian($carerId: String!, $dependantId: String!) {
    addCarer(carerId: $carerId, dependantId: $dependantId)
  }
`
